import React from 'react';
import {RoutePaths} from "../config/routeConstants";
import LoadingSpinner from "../components/common/LoadingSpinner";
import {Navigate, Outlet, useLocation} from 'react-router-dom';
import {useAuth} from '../contexts/AuthContext';
import {useUser} from "../contexts/UserContext";
import {useFeatureConfig} from "../contexts/FeatureConfigContext";
import {USER_ROLES} from "../models/users.models";

const PrivateRoute = () => {
    const {isAuthenticated, isVerifying} = useAuth();
    const {user, isLoadingUser} = useUser();
    const {isConfigLoading} = useFeatureConfig();
    const location = useLocation();

    if (isVerifying || isLoadingUser || isConfigLoading) {
        return <LoadingSpinner/>;
    }

    const isUserAuthenticated = isAuthenticated && user && Object.values(USER_ROLES).includes(user.role);

    return isUserAuthenticated ? (
        <Outlet/>
    ) : (
        <Navigate to={RoutePaths.Login} replace state={{from: location}} />
    );
};

export default PrivateRoute;
